import { render, staticRenderFns } from "./GroupSection.vue?vue&type=template&id=d2534cec&"
import script from "./GroupSection.vue?vue&type=script&lang=js&"
export * from "./GroupSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports